import React, { useState } from "react";
import "./DMCA.scss";
import { Link, useLocation } from "react-router-dom";

const RightComponent = (active) => {
  const location = useLocation();
  return (
    <div id="dmca">
      <div className="py-3">
        <Link to={{ pathname: "/privacy-policy" }} className={`text-dark text-decoration-none ${location.pathname === "/privacy-policy" && "active"}`}>
          {" "}
          Privacy Policy
        </Link>
      </div>

      <div className="py-3">
        <Link to={{ pathname: "/review-policy" }} className={`text-dark text-decoration-none ${location.pathname === "/review-policy" && "active"}`}>
          {" "}
          Review Policy
        </Link>
      </div>

      <div className="py-3">
        <Link to={{ pathname: "/ad-post-policy" }} className={`text-dark text-decoration-none ${location.pathname === "/ad-post-policy" && "active"}`}>
          {" "}
          Ad Post Policy
        </Link>
      </div>

      <div className="py-3">
        <Link to={{ pathname: "/dmca" }} className={`text-dark text-decoration-none ${location.pathname === "/dmca" && "active"}`}>
          {" "}
          DMCA
        </Link>
      </div>

      <div className="py-3">
        <Link to={{ pathname: "/comment-policy" }} className={`text-dark text-decoration-none ${location.pathname === "/comment-policy" && "active"}`}>
          {" "}
          Comment Policy
        </Link>
      </div>

      <div className="py-3">
        <Link to={{ pathname: "/terms-condition" }} className={`text-dark text-decoration-none ${location.pathname === "/terms-condition" && "active"}`}>
          {" "}
          Terms & Condition
        </Link>
      </div>
    </div>
  );
};

export default RightComponent;
